<template>
  <printBase ref="LinkQR032" :title='title' :page='page'>
    <div v-for="(printInfo, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">不合格药品报告确认表</div>
      <div style="float:right">
        <span style="margin-right:60px;">报告人：</span>
        <span style="margin-right:30px;">年</span>
        <span style="margin-right:30px;">月</span>
        <span>日</span>
      </div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 6%;">商品码</th>
          <th style="width: 12%;">品名</th>
          <th style="width: 10%;">剂型</th>
          <th style="width: 8%;">规格</th>
          <th style="width: 10%;">生产厂家</th>
          <th style="width: 6%;">数量</th>
          <th style="width: 7%;">批号</th>
          <th style="width: 8%;">有效期至</th>
          <th style="width: 8%;">购进日期</th>
          <th style="width: 13%;">不合格原因</th>
          <th style="width: 6%;">不合格情况复查</th>
          <th style="width: 6%;">备注</th>
        </tr>
        <tbody>
          <tr v-for="(item, printIndex) in printInfo" :key="printIndex">
            <td><span>{{ item.drugSerialCode}}</span></td>
            <td><span>{{ item.approvedDrugNames}}</span></td>
            <td><span>{{ item.dosageForm}}</span></td>
            <td><span>{{ item.specifications}}</span></td>
            <td><span>{{ item.manufacturer}}</span></td>
            <td><span>{{ item.unqualifiedCount}}</span></td>
            <td><span>{{ item.goodsBatchNumber}}</span></td>
            <td><span>{{ item.expiryDate}}</span></td>
            <td><span>{{ item.purchaseTime}}</span></td>
            <td><span>{{ item.applyReason}}</span></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>
        </tbody>

      </table>
      <div>
          <span style="margin-left:50px;">质量负责人：</span>
          <span style="margin-left:700px;">采购负责人：</span>
        </div>
    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-032',
      printInfoList: [],
      page: 1,
      pageSize: 15,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(unqualifiedRecordIds) {
      inventory.getUnqualifiedPrintData({ unqualifiedRecordIds }).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          const resultList = [];
          res.data.data.forEach((item) => {
            item.expiryDate = utils.exchangeTime(item.expiryDate);
            item.purchaseTime = utils.exchangeTime(item.purchaseTime);

            resultList.push(item);
          });
          this.printInfoList = _.chunk(resultList, this.pageSize);
          this.page = this.printInfoList.length;
          this.$nextTick(() => {
            this.$refs.LinkQR032.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      height: 38px;
      max-height: 32px;
      overflow:hidden
    }

  }
</style>
